import React, {Component} from "react";
import {PerfilNavegacao} from 'react-template'
import Nav from './Nav';
import {getImagemDoUsuario, getDadosDoUsuario} from "../../view/dashboard/UserActions"
import {connect} from 'react-redux';

class Navbar extends Component {

    constructor(props){
        super(props);
        this.state = { imagemUsuario: null, nomeUsuario: ''};
    }

    componentWillMount(){
        this.getFotoDoUsuario();
        this.getDadosUsuario();
    }

    getUserRolesString(){
        const roles = this.props.auth.roles
        if(roles.length > 0)
            return roles.join(", ");
        return 'Usuário não está logado';
    }

    getFotoDoUsuario(){
        getImagemDoUsuario(res=>{
            const imagemUsuario = res.data
            this.setState({...this.state, imagemUsuario})
        }, 
        error=>{
            console.log('Usuario sem Imagem de Perfil.')
        })
    }

    getDadosUsuario(){
        getDadosDoUsuario(res => {
            const nomeUsuario = res.data.nomeReduzido.trim().length > 0 ? res.data.nomeReduzido : this.props.auth.username
            this.setState({...this.state, nomeUsuario})
        },
        error => {
            const nomeUsuario = this.props.auth.username
            this.setState({...this.state, nomeUsuario})
        })
    }


    render() {
        return (
            <div className="aside">
                <PerfilNavegacao username={this.state.nomeUsuario} grupo={this.getUserRolesString()} imagem={this.state.imagemUsuario}/>
                <Nav/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {auth: state.auth};
}

export default  connect(mapStateToProps)(Navbar)


// WEBPACK FOOTER //
// ./src/components/navegacao/Navbar.js